import React, { useState } from 'react';
import { Modal, Button } from '../shared/Modal';
import { Field, TextInput } from '../shared/FormFields';

// The second of the two delete-workspace confirmations. Deleting no longer
// requires emptying the workspace first — the server cascades everything it
// scopes — which is exactly why this one is type-to-confirm rather than a
// second plain "are you sure": the click after this is unrecoverable.
//
// Not built on ConfirmDialog for the same reason TransferOwnershipDialog
// isn't: a Field can't legally nest inside its <p> message.

const list = { margin: '0 0 16px', paddingLeft: '18px', fontSize: '13px', lineHeight: 1.7, color: 'var(--text-secondary, #64748b)' };

const norm = (v) => String(v || '').trim().toLowerCase();

export default function DeleteWorkspaceDialog({ name, busy = false, onConfirm, onClose }) {
  const [typed, setTyped] = useState('');
  const matches = norm(typed) === norm(name);

  const confirm = () => {
    if (!matches || busy) return;
    onConfirm();
  };

  return (
    <Modal
      title="Permanently delete this workspace?"
      width={480}
      busy={busy}
      onClose={onClose}
      footer={(
        <>
          <Button onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant="danger" onClick={confirm} disabled={!matches || busy}>
            {busy ? 'Deleting…' : 'Permanently delete'}
          </Button>
        </>
      )}
    >
      <ul style={list}>
        <li><strong>{name}</strong> is deleted for everyone, along with everything in it:</li>
        <li>its agents, data sources, knowledge entries, uploaded files and data connections;</li>
        <li>run history and dashboards are kept, moved to the account level;</li>
        <li>this cannot be undone.</li>
      </ul>

      <Field label={`Type ${name} to confirm`}>
        <TextInput
          value={typed}
          onChange={setTyped}
          placeholder={name}
          onKeyDown={(e) => { if (e.key === 'Enter') confirm(); }}
        />
      </Field>
    </Modal>
  );
}
